import { MediaArticleInformationPage } from "./ArticleInformationPage/MediaArticleInformationPage";
import { AggregatedArticleView } from "@coworker/app/src/components/RoomSettings/Articles/AggregatedArticleView";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { SearchedArticleView } from "@coworker/app/src/components/RoomSettings/Articles/SearchedArticleView";
import { MediaArticleInformationPageSearch } from "./ArticleInformationPage/MediaArticleInformationPageSearch/MediaArticleInformationPageSearch";

export const MediaArticleInformationLandingPage = () => {
  const enableNewMediaPIPPage = useFlag(FLAGS.ENABLE_NEW_MEDIA_PIP_PAGE);

  if (enableNewMediaPIPPage) {
    return <MediaArticleInformationPage />;
  }

  return <AggregatedArticleView />;
};

export const MediaArticleInformationLandingPageSearch = () => {
  const enableNewMediaPIPPage = useFlag(FLAGS.ENABLE_NEW_MEDIA_PIP_PAGE);

  if (enableNewMediaPIPPage) {
    return <MediaArticleInformationPageSearch />;
  }

  return <SearchedArticleView />;
};
